import styled from "styled-components";

const JobContainerStyled = styled.div.withConfig({
      shouldForwardProp: (prop) => !['activeIndex','forceRight'].includes(prop)
})`
    
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    width: 95%;
    margin: 0 auto;
    height: 70vh;
      .jobList{
            display: ${({ activeIndex, forceRight }) =>
                        activeIndex === null && !forceRight ? "flex" : "none"};        
        width: 100%;
        background: ${({theme})=> theme === 'dark' ? '#0C1E28' : '#fff'};
        border: 1px solid #5fbec5;
        padding: 1rem;
        height: inherit;
        overflow: hidden;
        border-radius: 1rem;
        
    }
    .jobView{
      display: ${({ activeIndex, forceRight }) => (activeIndex !== null || forceRight) ? "flex" : "none"};
      flex-direction: ${({ activeIndex }) => activeIndex === null ? "column" : "row"};
      justify-content: ${({ activeIndex }) => activeIndex === null && 'center'};
      align-items: ${({ activeIndex }) => activeIndex === null && 'center'};
      background: ${({theme})=> theme === 'dark' ? '#0C1E28' : '#fff'};
      width: 100%;
      border: 1px solid #5fbec5;
      padding: 1rem;
      height: inherit;
      overflow-y: auto;
      overflow-x: hidden;
      border-radius: 1rem;
    }
    @media only screen and (min-width: 992px) {
        flex-direction: row;
        .jobList{
            display: flex;
            width: 30%;

        }
        .jobView{
            display: flex;
            width: 75%;
        }
    }
`

const JobListStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    max-width: 100%;
    .sectionTitle{
        font-size: 1.5rem;
        margin-bottom: 0.5rem;      
    }

`

const JobViewStyled = styled.div`
      display: flex;
      flex-direction: column;
      gap: 1rem;
      width: 100%;
      max-width: 100%;

      .header {
            display: flex;
            justify-content: space-between;
            //border-bottom: 1px solid #5fbec5;

            .sectionTitle {
                  font-size: 1.5rem;
                  //padding: 0.7rem 0;
            }

            button {
                  border: none;
                  cursor: pointer;
                  color: #5fbec5;
                  background: none;
                  font-size: 1.5rem;
            }

      }

      /* Ensure processing header buttons (minimize/stop) are visible even on desktop */
      .processing-header button {
            display: inline-flex;
      }

      .sectionOne {
            display: flex;
            flex-direction: column;
            gap: 0.6rem;
            //padding: 0 0 1rem 0;
            //border-bottom: 1px solid #5fbec5;

            .firstLayer {
                  flex: 1;
                  max-width: 100%;
                  display: flex;
                  justify-content: start;
                  gap: 1rem;

                  .jobRoleNCompany {
                        min-width: 0; /* 🔑 allows ellipsis inside flex */
                        flex: 1; /* take up remaining space */

                        h1 {
                              font-size: 1.1rem;
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              max-width: 100%;

                              @media only screen and (min-width: 992px) {
                                    font-size: 1.3rem;
                              }
                        }

                        p {
                              font-size: 0.9rem;
                              color: #5fbec5;
                              text-transform: capitalize;

                              span {
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                              }
                        }
                  }
            }

            .secondLayer {
                  display: flex;
                  gap: 0.6rem;


                  p {
                        font-size: .6rem;
                        padding: 0.2rem 0.8rem;
                        color: ${({theme}) => theme === 'dark' ? '#0C1E28' : '#fff'};
                        background: ${({theme}) => theme === 'dark' ? '#fff' : '#5fbec5'};
                        width: fit-content;
                        border-radius: 1.25rem;
                  }
            }
      }

      .aiLinks {
            display: flex;
            flex-direction: column;
            border-top: .02rem solid #5fbec5;
            border-bottom: .02rem solid #5fbec5;

            h3 {
                  padding: 0.8rem 0 0 0;
            }

            .actionButtons {
                  display: inline-flex;
                  flex-flow: row wrap;
                  justify-content: start;
                  align-items: center;

                  padding: 1rem 0;
                  gap: .5rem;

                  .items {
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                        padding: 0.5rem 0.8rem;
                        border-radius: 1.25rem;
                        border: none;
                        width: fit-content;
                        background: none;
                        color: ${({theme}) => theme === 'dark' ? '#fff' : '#0C1E28'};
                        cursor: pointer;
                        transition: 0.5s ease-in-out;
                        transform: scale(1);
                        font-size: .7rem;

                  }

                  .getJob {
                        border: 1px solid #f5df44;

                        & > :first-child {
                              color: #f5df44;
                        }

                        &:hover {
                              background: #f5df44;
                              color: #fff;

                              & > :first-child {
                                    color: #fff;
                              }
                        }
                  }

                  .getResume {
                        border: 1px solid #418e93;

                        & > :first-child {
                              color: #418e93;
                        }

                        &:hover {
                              background: #418e93;
                              color: #fff;

                              & > :first-child {
                                    color: #fff;
                              }
                        }
                  }

                  .getCover {
                        border: 1px solid #996e75;

                        & > :first-child {
                              color: #996e75;
                        }

                        &:hover {
                              background: #996e75;
                              color: #fff;

                              & > :first-child {
                                    color: #fff;
                              }
                        }
                  }

                  .followUp {
                        border: 1px solid #fb5607;

                        & > :first-child {
                              color: #fb5607;
                        }

                        &:hover {
                              background: #fb5607;
                              color: #fff;

                              & > :first-child {
                                    color: #fff;
                              }
                        }
                  }

                  .prep {
                        border: 1px solid #8338ec;

                        & > :first-child {
                              color: #8338ec;
                        }

                        &:hover {
                              background: #8338ec;
                              color: #fff;

                              & > :first-child {
                                    color: #fff;
                              }
                        }
                  }

                  .messageRecruiter {
                        border: 1px solid #3a86ff;

                        & > :first-child {
                              color: #3a86ff;
                        }

                        &:hover {
                              background: #3a86ff;
                              color: #fff;

                              & > :first-child {
                                    color: #fff;
                              }
                        }
                  }

                  .deleteJob {
                        border: 1px solid crimson;

                        & > :first-child {
                              color: crimson;
                        }

                        &:hover {
                              background: crimson;
                              color: #fff;

                              & > :first-child {
                                    color: #fff;
                              }
                        }
                  }
                  .tryAgain {
                        border: 1px solid #f76903ff;

                        & > :first-child {
                              color: #f76903ff;
                        }

                        &:hover {
                              background: #f76903ff;
                              color: #fff;

                              & > :first-child {
                                    color: #fff;
                              }
                        }
                  }
            }

      }

      .jobSuitability {
            display: flex;
            flex-direction: column;
            border-bottom: .02rem solid #5fbec5;
            

            .dataSection {
                  display: inline-flex;
                  flex-flow: row wrap;
                  justify-content: start;
                  align-items: stretch;
                  padding: 1rem 0;
                  gap: .5rem;
            }
      }

      .insights {
            display: flex;
            flex-direction: column;
            border-bottom: .02rem solid #5fbec5;

            h1 {
                  font-size: 1.5rem;
                  border-bottom: .02rem solid #5fbec5;
                  padding-bottom: 1rem;

            }

            .insightsConnects {
                  display: flex;
                  flex-direction: column;
                  padding: 0.5rem;
                  gap: 0.6rem;
            }

      }

      .summary {
            display: flex;
            flex-direction: column;
            gap: 1rem;

            .jobLine {
                  margin-bottom: 0.55rem;
                  line-height: 1.1;
            }
      }


      @media only screen and (min-width: 992px) {
            .header {

                  button {
                        display: none; /* default hide on desktop */
                        border: none;
                        cursor: pointer;
                        color: #5fbec5;
                        background: none;
                        font-size: 1.5rem;
                  }

            }

            /* Override for processing header on desktop */
            .processing-header button {
                  display: inline-flex;
            }

            .secondLayer {


                  p {
                        font-size: .9rem;

                  }
            }

            .sectionTwo {
                  .items {
                        font-size: .7rem;
                  }
            }
      }

`

const AssistSectionStyled = styled.div`
    display: flex;
    flex-direction: column;
      justify-content: center;
      align-items: center;
    gap: 1rem;
    margin: 2rem auto;

    @media only screen and (min-width: 992px) {
        flex-direction: row;
          
    }


`

const SuitabilitySpanStyled = styled.span.withConfig({
      shouldForwardProp: (prop) => !['matched'].includes(prop)
})`
      width: ${({matched})=> matched ? '25%' : '22%' };
      border: 1px solid ${({matched, theme})=> matched ? theme === "dark" ? 'rgb(0, 153, 144)': '#5fbec5' : theme === "dark" ? 'rgba(0, 153, 144, 0.5)' : 'rgba(95, 190, 197, 0.5)'};
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      border-radius: 1.25rem;
      @media only screen and (min-width: 992px) {
            width: ${({matched})=> matched ? '15%' : '10%' };


      }

            p {
            text-align: center;
            padding: 0.4rem;
            width: 100%;
            background: ${({matched, theme})=> matched ? theme === "dark" ? 'rgb(0, 153, 144)': '#5fbec5' : theme === "dark" ? 'rgba(0, 153, 144, 0.5)' : 'rgba(95, 190, 197, 0.5)'};
            overflow: hidden;
            border-bottom-left-radius: 1.25rem;
            border-bottom-right-radius: 1.25rem;
            text-transform: ${({matched})=> matched && 'uppercase'};
      }

      :first-child {
            width: 100%;
            border-radius: 0;
            padding: 0.9rem 0;
            font-size: ${({matched})=> matched && '1.5rem'};
            background: none;
      }
      :nth-child(1) {
            
      }

      .percent {
            font-size: 0.7rem;
            border: none;
      }
`

const OverflowContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none; 
    -ms-overflow-style: none; 
    &::-webkit-scrollbar {
        width: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
        background: #5fbec5;
    }
    &::-webkit-scrollbar {
        opacity: 0;
        transition: opacity 0.3s ease;
    }
    &:hover::-webkit-scrollbar {
        opacity: 1;
    }
    scrollbar-width: thin;
    scrollbar-color: #5fbec5 transparent;
`;

const ImageAltStyled = styled.span`
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    background: ${({theme})=> theme === 'dark' ? '#0C1E28' : '#fff'};
    border: 1px solid ${({theme})=> theme === 'dark' ? '#fff' : '#5fbec5'};
    color: ${({theme})=> theme === 'dark' ? '#fff' : '#0C1E28'};
    border-radius: 50%;
    overflow: hidden;

    h1 {
        font-size: 1rem;
    }
      img{
            object-fit: cover;
            width: 100%;
            height: 100%;
            object-position: center;
            border-radius: 50%;
      }
`;

const JobCardStyled = styled.div.withConfig({
      shouldForwardProp: (prop) => !['active', 'activeIndex', 'isApplied'].includes(prop)
})`
      background: ${({ theme, active }) =>
          active 
              ? "rgba(57, 104, 107, 0.95)"
              : theme === "dark"
                  ? "linear-gradient(to bottom, rgba(111, 203, 209, 0.9), rgba(57, 104, 107, 0.95))"
                  : "#fff"};
      box-shadow: ${({ active }) =>
          active 
              ? `
        inset 2px 2px 4px rgba(0, 0, 0, 0.3),
        inset -2px -2px 4px rgba(0, 0, 0, 0.7)
      `
              : `
        0 2px 1px rgba(0, 0, 0, 0.07)
      `};
      transform: ${({ active }) => (active ? "scale(0.97)" : "scale(1)")};
      transition: all 0.15s ease-in-out;
      cursor: ${({ isApplied }) => (isApplied ? 'not-allowed' : 'pointer')};
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: .8rem;
      padding: ${({ theme }) => theme === 'dark' ? '0.5rem 1rem' : '0.5rem 1rem'};
      padding-bottom: 1.1rem; /* extra space for bottom badge */
      min-height: 84px;
      border-radius: 0.625rem;
      opacity: ${({ isApplied }) => (isApplied ? 0.45 : 1)};
      filter: ${({ isApplied }) => (isApplied ? 'grayscale(0.6) blur(0px)' : 'none')};
      pointer-events: ${({ isApplied }) => (isApplied ? 'auto' : 'auto')};
      .content {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            padding-top: 0;
           gap: 0.3rem;
           justify-content: start;

          h1 {
              font-size: 1rem;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
          }

          p {
              display: flex;
              gap: 0.3rem;
              align-items: center;
              font-size: .8rem;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis; 
                span {
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                }
          }
            
      }
`;

const RuleStyled = styled.div`
  width: 100%;
  height: 1px;
  background-color: #5fbec5;
`;

const NoConnectionViewStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    .alert{
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FEFFD8;
        width: fit-content;
        margin: 0 auto;
        gap: 1rem;
        border-radius: .8rem;
        padding: 1rem;
        h2{
            color: #0C1E28;
            font-size: .9rem;
            font-weight: 500;
        }
    }
    .tipsContainer{
        display: flex;
        flex-direction: column;
        gap: 1rem;
        border: 1px solid #5fbec5;
        border-radius: .8rem;
        width: 95%;
        margin: 0 auto;
        background: #fff;
        color: #0C1E28;
        padding: 1rem;

        .tip{
            display: flex;
            gap: 1rem;
            align-items: center;
            border-bottom: 1px solid #5fbec5;
            padding: 1rem 0;
            h2{
                color: #0C1E28;
                font-size: .9rem;
                font-weight: 500;
            }
        }
            
    }
`

export {NoConnectionViewStyled, JobViewStyled,JobListStyled,JobContainerStyled, AssistSectionStyled, OverflowContainerStyled, ImageAltStyled, JobCardStyled, RuleStyled, SuitabilitySpanStyled};